import React, { useState, useEffect, useMemo } from 'react';
import { useModalContext } from '../../CustomModal/ModalProvider.jsx';
import {
  StyledButtonCancelar,
  StyledButtonDownload,
  StyledButtonLogs,
  ListItemDiv,
  ListSubItemDiv,
  ListItemDivContract,
  StyledButtonConfirmarDocs,
  StyledButtonIniciarEtapa,
  StyledButtonIniciado,
  StyledButtonCriarContract,
  StyledButtonMintNft,
  styleFileUpload,
  ContractItem,
  ContractLabel,
  ContractValue,
  StyledButtonVerContrato,
  ModalOverlay,
  ModalContent,
  ModalTitle,
  CloseButton,
  ContractContainer,
  subTopicos,
} from '../styles';
import { FileUploadComponentPDF } from './Actions/FileUploadComponentPDF';
import ProgressBar from './ProgressBar/ProgressBar.jsx';
import ProgressBar2 from './ProgressBar2';
import { v4 as uuidv4 } from 'uuid';
import FUDeleteButton from './FUDeleteButton';
import FUSalvarButton from './FUSalvarButton';
import { protectPDF } from '../SmartContract/protectPDF';
import { criarContract } from './Actions/CriarContract';
import { FaFileContract, FaPlus } from 'react-icons/fa';
import { useEnviarFile } from './Actions/EnviarFile';
import { useSelectFile } from './Actions/FileUploadComponentPDF';
import { useMintarNft } from './Actions/MintarNFT';
import { ShowNftInfoButton } from './Actions/ExibeNFT';
import { cancelarFile } from './Actions/CancelarFile';
import { mostrarLogs } from './Actions/MostrarLogs';
import { iniciarEtapa } from './Actions/IniciarEtapa';
import { useLocation } from 'react-router-dom';
import { MergeArquivo } from './Actions/Merge/MergeArquivo';
import { BuscaMerge } from './Actions/Merge/BuscaMerge';
import { CancelarMerge } from './Actions/Merge/CancelMerge';
import { DownloadMerge } from './Actions/Merge/DownloadMerge';
import MintButton from './Actions/Merge/MintButton.jsx';
import LogsMerge from './Actions/Merge/LogsMerge/LogsMerge.jsx'
import { blockchainService } from '../../../services/blockchainService.js';

export const sanitizeBigInt = (obj) => {
  if (typeof obj !== 'object' || obj === null) return obj;

  for (const key in obj) {
    if (typeof obj[key] === 'bigint') {
      obj[key] = obj[key].toString();
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      sanitizeBigInt(obj[key]);
    }
  }
  return obj;
};

export const recarregarContract = async (
  project_id,
  headers,
  setFileManagerContract,
  setContractAddressDeploy,
  setContractAddressClient,
  setContractWalletOwner,
  setContractProjectName,
  setContractProjectOwner,
  setContractCar,
  setContractCnpjCpf
) => {
  try {
    const data = await blockchainService.getContractInfo(project_id, headers);

    setFileManagerContract(data.id || '');
    setContractAddressDeploy(data.ContratoAddress || '');
    setContractAddressClient(data.ContratoClienteAddress || '');
    setContractWalletOwner(data.Signer || '');
    setContractProjectName(data.ProjectName || '');
    setContractProjectOwner(data.ProjectOwner || '');
    // ProjectCAR é array de strings; exibe como string separada por vírgula
    setContractCar(Array.isArray(data.ProjectCAR) ? data.ProjectCAR : (data.ProjectCAR || ''));
    setContractCnpjCpf(data.ProjectCnpjCpf || '');

    return {
      contract_file_manager_contract: data.id,
      contract_contract_address_client: data.ContratoClienteAddress,
      contract_wallet_owner: data.Signer,
      contract_contract_address_deploy: data.ContratoAddress,
      contract_project_name: data.ProjectName,
      contract_project_owner: data.ProjectOwner,
      contract_car: data.ProjectCAR,
      contract_cnpj_cpf: data.ProjectCnpjCpf,
      ...data
    };
  } catch (error) {
    console.error('Erro ao carregar dados do contrato:', error);
    throw error;
  }
};

export const recarregarTela = async (modelo_GUID, headers, project_id, setdocMap) => {
  try {
    const data = await blockchainService.getDocumentModelData(modelo_GUID, project_id, headers);
    setdocMap({ ...data });
  } catch (error) {
    console.error('Erro ao recarregar dados da tela:', error);
  }
};

const FileUploadBlockchain = ({ project_id, tela_name, modelo_GUID, confirmacao_doc = false }) => {
  const { showWarning, showConfirm, showSuccess, showError } = useModalContext();
  const token = sessionStorage.getItem('Authorization');
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }), [token]);
  const [docMap, setdocMap] = useState({});
  const { mintarNft } = useMintarNft();
  const [mergedDocs, setMergedDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isContractConfirmed, setContractConfirmed] = useState(false);
  const { enviarFile } = useEnviarFile();
  const getFileStates = () => fileStates;
  const [fileStates, setFileStates] = useState({});
  const [contract_file_manager_contract, setFileManagerContract] = useState('');
  const [contract_contract_address_deploy, setContractAddressDeploy] = useState('');
  const [contract_contract_address_client, setContractAddressClient] = useState('');
  const [contract_wallet_owner, setContractWalletOwner] = useState('');
  const [contract_project_name, setContractProjectName] = useState('');
  const [contract_project_owner, setContractProjectOwner] = useState('');
  const [contract_car, setContractCar] = useState('');
  const [contract_cnpj_cpf, setContractCnpjCpf] = useState('');
  const [showContractModal, setShowContractModal] = useState(false);
  const [isBotaoSalvar, setBotaoSalvar] = useState(false);
  const [uploadProgresses, setUploadProgresses] = useState({});
  const [uploading, setUploading] = useState({});
  const [uploadSuccess, setUploadSuccess] = useState({});
  const [expandedTopics, setExpandedTopics] = useState([]);
  const [isChecked, setChecked] = useState(false);
  const { state } = useLocation();
  const projetoId = state?.project?.id;
  const [isDocConfirmed, setDocConfirmed] = useState(false);
  const [reloadTrigger, setReloadTrigger] = useState(0); // novo estado de controle
  const [documentMergeStatus, setDocumentMergeStatus] = useState({});

  const recarregaMerge = () => {
    setReloadTrigger(prev => prev + 1); // força atualização
  };

  const { handleSelectFile } = useSelectFile({
    uuidv4,
    setFileStates,
    project_id,
    tela_name,
    fileStates
  });

  useEffect(() => {
    if (!token) {
      setError('Authorization token not found');
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);

        const modelResponse = await blockchainService.getDocumentModelData(
          modelo_GUID,
          project_id,
          headers
        );
        setdocMap(modelResponse);

        await recarregarContract(
          project_id,
          headers,
          setFileManagerContract,
          setContractAddressDeploy,
          setContractAddressClient,
          setContractWalletOwner,
          setContractProjectName,
          setContractProjectOwner,
          setContractCar,
          setContractCnpjCpf
        );
      } catch (err) {
        setError(err.message);
        console.error('API Error:', err);

        if (err.response?.status === 401) {
          console.error('Session expired - please login again');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [project_id, modelo_GUID, headers, token]);

  //use effect para buscar merge
  useEffect(() => {
    const fetchMergeDocs = async () => {
      const token = sessionStorage.getItem('Authorization');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        // 🔹 Usando o serviço centralizado
        const mergedDocsData = await blockchainService.getMergedDocuments(headers);
        setMergedDocs(mergedDocsData);
      } catch (error) {
        console.error('Erro ao buscar documentos mesclados:', error);
      }
    };

    fetchMergeDocs();
  }, [reloadTrigger]);

  const switchField = (fieldName) => {
    setFileStates(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  useEffect(() => {
    const checkMerges = async () => {
      const status = {};

      for (const topic of Object.keys(docMap)) {
        for (const item of docMap[topic].questoes) {
          if (!item.document_guid) {
            status[item.modelo_item_id] = false;
            continue;
          }
          try {
            const temMerge = await blockchainService.verificarMergeDocumento(item.document_guid, headers);

            status[item.document_guid] = temMerge;
          } catch (err) {
            console.error(`❌ Erro ao verificar merge do documento ${item.document_guid}:`, err);
            status[item.document_guid] = false;
          }
        }
      }
      setDocumentMergeStatus(status);
    };

    if (docMap) {
      checkMerges();
    }
  }, [docMap, headers]);

  const toggleTopic = (topic) => {
    if (expandedTopics.includes(topic)) {
      setExpandedTopics(expandedTopics.filter((t) => t !== topic));
    } else {
      setExpandedTopics([...expandedTopics, topic]);
    }
  }

  async function abrirDocumentoNavegadorDoBanco(guid, ext, mime_type) {
    try {
      const retorno = await protectPDF(guid, null);
      const token = sessionStorage.getItem('Authorization');
      const headers = { Authorization: `Bearer ${token}` };

      // Usando o serviço centralizado
      const fileData = await blockchainService.downloadDocument(project_id, tela_name, guid, ext, retorno.signature, headers);

      const tipoMIME = mime_type || fileData.type || 'application/octet-stream';
      const fileURL = URL.createObjectURL(new Blob([fileData], { type: tipoMIME }));

      const novaJanela = window.open();
      if (novaJanela) {
        novaJanela.document.write(`<iframe width="100%" height="100%" src="${fileURL}"></iframe>`);
      } else {
        console.error('Falha ao abrir uma nova janela do navegador.');
      }

    } catch (error) {
      console.error('Erro ao buscar o arquivo:', error);
    }
  }

  const handleConfirmacaoDocumentos = async (_topico_id) => {
    if (!isChecked) {
      console.warn('⚠️ Nenhum checkbox selecionado!');
      showWarning('Atenção!', 'Selecione a confirmação de documentos, para confirmar!');
      return;
    }

    const token = sessionStorage.getItem('Authorization');
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const confirm = await showConfirm(
        'Confirmação',
        'Deseja realmente confirmar os documentos para esta etapa?'
      );

      if (!confirm) return;

      // 1️⃣ Atualiza os controles
      await blockchainService.updateFileManagerControls(project_id, _topico_id, headers);
      showSuccess('Sucesso!', 'Documentos confirmados com sucesso!');

      // 2️⃣ Recarrega os dados do modelo de documento
      const data = await blockchainService.getDocumentModelData(modelo_GUID, project_id, headers);
      setdocMap({ ...data });

    } catch (error) {
      console.error('❌ Erro durante a confirmação de documentos:', error);
      showError('Erro!', 'Ocorreu um problema ao confirmar os documentos. Por favor, tente novamente.');
    }
  };

  const handleEtapaIniciada = (_topico_id) => {
    showWarning('Atenção!', 'Esta etapa já está ativa.');
  }

  const contarDocumentNamePreenchidos = (data, topicToCalculate) => {
    const questoes = data[topicToCalculate]?.questoes || [];
    return questoes.filter(q => q.document_name).length;
  };

  const verificarUploadVisivel = (data, topicToCheck) => {
    const primeiraQuestao = data[topicToCheck]?.questoes?.[0];
    return primeiraQuestao?.file_manager_control?.visible_upload === true || primeiraQuestao?.file_manager_control?.visible_update === true;
  };

  const contarDocumentOkTrue = (data, etapa) => {
    const questoes = data[etapa]?.questoes || [];
    return questoes.filter(q => q.file_manager_control?.document_ok === true).length;
  };

  const TopicoCount = (data, topico) => {
    return data[topico]?.questoes?.length || 0;
  };

  const verificarDocsConfirmados = async () => {
    const token = sessionStorage.getItem('Authorization');
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const response = await blockchainService.getConfirmedDocumentsCount(project_id, headers);
      const { requirements_met, total_confirmed } = response?.data || response || {};

      const allRequirementsMet =
        requirements_met?.comercial &&
        requirements_met?.juridico &&
        requirements_met?.engenharia &&
        total_confirmed >= 9;

      setDocConfirmed(allRequirementsMet);
      return allRequirementsMet;

    } catch (error) {
      console.error('❌ Erro ao buscar documentos confirmados:', error);
      setDocConfirmed(false);
      return false;
    }
  };

  useEffect(() => {
    verificarDocsConfirmados();
  }, [project_id]);

  const getContract = async () => {
    const token = sessionStorage.getItem('Authorization');
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const response = await blockchainService.getContractStatus(project_id, headers);

      if (response.confirmed_contract_count > 0) {
        setContractConfirmed(true);
        return true;
      } else {
        setContractConfirmed(false);
        return false;
      }

    } catch (error) {
      console.error('Erro ao buscar documentos do contrato:', error);
      setContractConfirmed(false);
      return false;
    }
  };

  return (
    <div >
      <div style={styleFileUpload.containerFileUpload}>
        <h2 style={styleFileUpload.centerTitle}>{tela_name}</h2>
        {isDocConfirmed && (
          <div>
            <ListItemDivContract>
              {contract_contract_address_client === "" ? (
                <StyledButtonCriarContract
                  onClick={() =>
                    criarContract(
                      project_id,
                      modelo_GUID,
                      setdocMap,
                      projetoId,
                      setFileManagerContract,
                      setContractAddressDeploy,
                      setContractAddressClient,
                      setContractWalletOwner,
                      setContractProjectName,
                      setContractProjectOwner,
                      setContractCar,
                      setContractCnpjCpf
                    )
                  }
                >
                  <FaPlus /> Criar Contract
                </StyledButtonCriarContract>
              ) : (
                <>
                  <StyledButtonVerContrato onClick={() => setShowContractModal(true)}>
                    <FaFileContract /> Exibir Contrato
                  </StyledButtonVerContrato>
                </>
              )}
            </ListItemDivContract>

            {showContractModal && (
              <ModalOverlay>
                <ModalContent>
                  <CloseButton onClick={() => setShowContractModal(false)}>×</CloseButton>
                  <ModalTitle>Informações do Contrato</ModalTitle>
                  <ContractContainer>
                    <ContractItem>
                      <ContractLabel>Projeto:</ContractLabel>
                      <ContractValue>{contract_project_name}</ContractValue>
                    </ContractItem>
                    <ContractItem>
                      <ContractLabel>Responsável:</ContractLabel>
                      <ContractValue>{contract_project_owner}</ContractValue>
                    </ContractItem>
                    <ContractItem>
                      <ContractLabel>CNPJ/CPF:</ContractLabel>
                      <ContractValue>{contract_cnpj_cpf}</ContractValue>
                    </ContractItem>
                    <ContractItem>
                      <ContractLabel>CAR:</ContractLabel>
                      <ContractValue>
                        {Array.isArray(contract_car) ? contract_car.join(', ') : (contract_car || '')}
                      </ContractValue>
                    </ContractItem>
                    <ContractItem>
                      <ContractLabel>Endereço do Contrato(Deploy):</ContractLabel>
                      <ContractValue>{contract_contract_address_deploy}</ContractValue>
                    </ContractItem>
                    <ContractItem>
                      <ContractLabel>Endereço do Contrato(Cliente):</ContractLabel>
                      <ContractValue>{contract_contract_address_client}</ContractValue>
                    </ContractItem>
                    <ContractItem>
                      <ContractLabel>Carteira Metamask:</ContractLabel>
                      <ContractValue>{contract_wallet_owner}</ContractValue>
                    </ContractItem>
                  </ContractContainer>
                </ModalContent>
              </ModalOverlay>
            )}
          </div>
        )}
        <ProgressBar data={docMap} />
        <div>
          {Object.keys(docMap).sort((a, b) => parseInt(a) - parseInt(b)).map((topic) => (
            <div key={topic} className="collapsible" >
              <ListItemDiv>
                <div style={styleFileUpload.progressBarContainer}>
                  <div style={styleFileUpload.expansor} className="header" onClick={() => toggleTopic(topic)}>
                    {expandedTopics.includes(topic) ? ` - ` : ` + `}
                  </div>
                  <div style={styleFileUpload.numberTopic}>
                    {docMap[topic].titulo ? `${topic})` : ``}
                  </div>

                  <div>
                    {docMap[topic].titulo ? <ProgressBar2 data={docMap} __topico={[topic]} /> : ``}
                  </div>

                  <div style={styleFileUpload.labelTopic}>
                    {docMap[topic].titulo ? `${docMap[topic].titulo.label}` : ``}
                  </div>

                  {
                    (confirmacao_doc ?
                      (((topic === '01' && !verificarUploadVisivel(docMap, '01')) ||
                        (topic !== '01' && contarDocumentNamePreenchidos(docMap, '01') === TopicoCount(docMap, '01')
                          && (contarDocumentOkTrue(docMap, '01') === TopicoCount(docMap, '01') && verificarDocsConfirmados() || !confirmacao_doc)
                          && verificarUploadVisivel(docMap, '01')
                          && !verificarUploadVisivel(docMap, topic))) ?
                        (<div style={styleFileUpload.buttonIniciar}>
                          <StyledButtonIniciarEtapa
                            onClick={() => iniciarEtapa(
                              docMap[topic].titulo.id,  // _topico_id
                              project_id,               // project_id
                              headers,                  // headers ✅
                              modelo_GUID,              // modelo_GUID ✅
                              setdocMap                 // setData2 ✅
                            )}
                          >
                            Iniciar {topic}
                          </StyledButtonIniciarEtapa>


                        </div>)
                        :
                        ((contarDocumentNamePreenchidos(docMap, '01') === TopicoCount(docMap, '01')
                          && (contarDocumentOkTrue(docMap, '01') === TopicoCount(docMap, '01') && verificarDocsConfirmados() || !confirmacao_doc) ||
                          (topic === '01' && verificarUploadVisivel(docMap, '01'))) &&
                          (<div style={styleFileUpload.buttonIniciar}>
                            <StyledButtonIniciado onClick={() => handleEtapaIniciada(topic)}>Iniciado</StyledButtonIniciado>
                          </div>)))
                      :
                      verificarDocsConfirmados() && !verificarUploadVisivel(docMap, topic) ?
                        (<div style={styleFileUpload.buttonIniciar}>
                          <StyledButtonIniciarEtapa
                            onClick={() => iniciarEtapa(
                              docMap[topic].titulo.id,  // _topico_id
                              project_id,               // project_id
                              headers,                  // headers ✅
                              modelo_GUID,              // modelo_GUID ✅
                              setdocMap                 // setData2 ✅
                            )}
                          >
                            Iniciar {topic}
                          </StyledButtonIniciarEtapa>
                        </div>)
                        :
                        (verificarDocsConfirmados() &&
                          (<div style={styleFileUpload.buttonIniciar}>
                            <StyledButtonIniciado onClick={() => handleEtapaIniciada(topic)}>Iniciado</StyledButtonIniciado>
                          </div>))
                    )
                  }
                </div>
              </ListItemDiv>

              {/* aqui mexe com na expanção dos documentos "subTopicos" */}
              {expandedTopics.includes(topic) && (
                //daqui 
                <div >
                  <ul style={{ fontSize: '8pt', listStyleType: 'none' }}>
                    {docMap[topic].questoes.map((item) => (
                      <li key={item.questao}>
                        <ListSubItemDiv>
                          <div style={subTopicos.container}>
                            <strong style={subTopicos.strongText}>
                              {topic}.{item.questao}
                            </strong>
                            {item.label} {item.document_name ? (
                              <div style={subTopicos.documentDiv}
                                onClick={() => abrirDocumentoNavegadorDoBanco(
                                  item.document_guid,
                                  item.document_ext,
                                  item.mime_type)}>
                                {item.document_ativo && (
                                  <b style={{ color: 'var(--info)' }}>
                                    (Documento: {item.document_name})
                                  </b>
                                )}

                              </div>
                            ) : ""}
                          </div>

                          {(
                            <div style={subTopicos.buttons}>

                              {item.file_manager_control.visible_upload && (
                                <div>
                                  {fileStates[item.fileNameFile] ? (
                                    <div >
                                      {uploading[item.fileNameFile] && (
                                        <progress value={uploadProgresses[item.fileNameFile] || 0} max="100">
                                          {uploadProgresses[item.fileNameFile] || 0}%
                                        </progress>
                                      )}
                                      {uploading[item.fileNameFile] ? (
                                        <div>
                                          <p>Enviando {uploadProgresses[item.fileNameFile] || 0}%</p>
                                        </div>
                                      ) : uploadSuccess[item.fileNameFile] ? (
                                        <div>
                                          <p>Sucesso!</p>
                                        </div>
                                      ) : (
                                        <>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <div>
                                              <FUSalvarButton
                                                disabled={isBotaoSalvar}
                                                handleUpload={() => enviarFile(fileStates[item.fileNameFile], item.fileNameFile, fileStates, modelo_GUID, project_id, setdocMap, setFileStates, setBotaoSalvar
                                                )}
                                                nome_arquivo={item.fileNameFile}
                                              />
                                            </div>
                                            <div style={{ float: 'left', width: '25px', marginLeft: '5px' }}>
                                              <FUDeleteButton
                                                switchField={() => switchField(item.fileNameFile)}
                                                nome_arquivo={item.fileNameFile}
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ) : (

                                    <FileUploadComponentPDF
                                      item={item}
                                      handleFileChange={(e) =>
                                        handleSelectFile(e, item.fileNameFile, item.modelo_item_id)
                                      }
                                      disabled={
                                        item.file_manager_control.visible_update &&
                                        contract_contract_address_client
                                      }
                                    />

                                  )}
                                </div>
                              )}

                              {item.file_manager_control.visible_logs &&
                                (<div style={{ float: 'left', marginLeft: '5px' }}>
                                  {item.log.length > 0 ? <StyledButtonLogs onClick={() => mostrarLogs(item.log)}>Logs</StyledButtonLogs> : ''}
                                </div>)}

                              {item.file_manager_control.visible_cancel && (
                                <div style={{ float: 'left', marginLeft: '5px' }}>
                                  {item.document_name && (
                                    <StyledButtonCancelar
                                      disabled={!item.document_ativo || documentMergeStatus[item.document_guid]}
                                      style={{
                                        backgroundColor: item.document_ativo && !documentMergeStatus[item.document_guid] ? '#FFA07A' : 'var(--border-default)', // cor de desabilitado
                                        cursor: item.document_ativo && !documentMergeStatus[item.document_guid] ? 'pointer' : 'not-allowed',
                                        opacity: item.document_ativo && !documentMergeStatus[item.document_guid] ? 1 : 0.6,
                                      }}
                                      onClick={() =>
                                        cancelarFile(
                                          item.document_guid,
                                          item.file_manager_nft_dt,
                                          item.file_manager_control.visible_show_nft,
                                          item.file_manager_control.file_manager_control_id,
                                          headers,
                                          contract_contract_address_client,
                                          contract_wallet_owner,
                                          modelo_GUID,
                                          project_id,
                                          setdocMap,
                                          setFileStates,
                                          setBotaoSalvar
                                        )
                                      }

                                    >
                                      Cancelar
                                    </StyledButtonCancelar>
                                  )}
                                </div>
                              )}

                              {/* botão para mintagem de arquivo */}
                              {item.file_manager_control.visible_mint_nft && contract_contract_address_client &&
                                docMap[topic].questoes.length === 1 && (
                                  <div style={{ float: 'left', marginLeft: '5px' }}>
                                    {item.document_name ? (
                                      <StyledButtonMintNft
                                        disabled={!item.document_ativo}
                                        style={{ backgroundColor: item.document_ativo ? '#F5DEB3' : 'var(--surface-1)' }}
                                        onClick={() => { mintarNft(item.document_guid, item.document_name, docMap[topic]['titulo'].id, item.document_path, project_id, modelo_GUID, headers, setdocMap, item.file_manager_control.file_manager_control_id, /*item.modelo_item_id*/); }}
                                      >
                                        Mint NFT
                                      </StyledButtonMintNft>
                                    ) : ''}
                                  </div>
                                )}

                              {/* NFT */}
                              {item.file_manager_control.visible_show_nft && contract_contract_address_client && (
                                <div style={{ float: 'left', marginLeft: '5px' }}>
                                  {item.document_name ? (
                                    <ShowNftInfoButton
                                      docId={item.document_guid}
                                    />
                                  ) : null}
                                </div>
                              )}

                              {item.file_manager_control.visible_download &&
                                (<div style={{ float: 'left', marginLeft: '5px' }}>
                                  {item.document_name ? <StyledButtonDownload disabled={!item.document_ativo} style={{ backgroundColor: item.document_ativo ? '#00FF7F' : 'var(--surface-1)' }} onClick={() => blockchainService.downloadDocumento(item.document_guid, item.document_ext, item.document_name, project_id, tela_name, headers, item.document_path)}>Download</StyledButtonDownload> : ''}
                                </div>)}
                            </div>
                          )}
                        </ListSubItemDiv>
                      </li>
                    ))}

                    {topic === '01' && contarDocumentNamePreenchidos(docMap, '01') === TopicoCount(docMap, '01')

                      && contarDocumentOkTrue(docMap, '01') < TopicoCount(docMap, '01') && confirmacao_doc && (
                        <div style={styleFileUpload.confirmContainer}>
                          <div style={styleFileUpload.checkboxArea}>
                            <input type="checkbox" id="confirmCheckbox" onChange={() => setChecked(!isChecked)} />
                          </div>
                          <label htmlFor="confirmCheckbox" style={styleFileUpload.labelConfirmacao}>
                            Confirmo que os documentos e informações declarados na ETAPA-1 estão corretas
                          </label>
                          <div style={styleFileUpload.botaoConfirmar}>
                            <StyledButtonConfirmarDocs
                              onClick={() => handleConfirmacaoDocumentos(docMap[topic].titulo.id)}
                              style={{
                                marginLeft: '10px',
                                backgroundColor: isChecked ? 'var(--accent)' : 'silver'
                              }}
                            >
                              Confirmar
                            </StyledButtonConfirmarDocs>
                          </div>
                        </div>
                      )}
                    {contract_contract_address_client?.trim() !== "" && docMap[topic].questoes.length > 1 && (
                      <ListSubItemDiv>
                        <div style={subTopicos.container}>
                          <strong style={subTopicos.strongText}>
                            {`MERGE: ${docMap[topic]?.titulo?.label || `Etapa ${topic}`}`}
                          </strong>
                          <BuscaMerge
                            projectId={project_id}
                            modeloId={modelo_GUID}
                            topicId={docMap[topic]?.titulo?.id}
                            reloadTrigger={reloadTrigger}
                          />
                        </div>

                        <div style={subTopicos.buttons}>
                          <MergeArquivo
                            projectId={project_id}
                            modeloDocumentId={modelo_GUID}
                            modeloTopicId={docMap[topic]?.titulo?.id}
                            recarregaMerge={recarregaMerge}
                          />

                          <LogsMerge
                            projectId={project_id}
                            modeloDocumentId={modelo_GUID}
                            modeloTopicId={docMap[topic]?.titulo?.id}
                          />

                          <CancelarMerge
                            projectId={project_id}
                            modeloDocumentId={modelo_GUID}
                            topicDocumentId={docMap[topic]?.titulo?.id}
                            recarregaMerge={recarregaMerge}
                            disabled={mergedDocs.some(
                              (merge) =>
                                merge.project_id === project_id &&
                                merge.topic_document === docMap[topic]?.titulo?.id &&
                                merge.is_minted
                            )}

                          />

                          <DownloadMerge
                            projectId={project_id}
                            modeloDocumentId={modelo_GUID}
                            modeloTopicId={docMap[topic]?.titulo?.id}
                          />


                          {mergedDocs
                            .filter(
                              (merge) =>
                                merge.project === project_id &&
                                merge.topic_document === docMap[topic]?.titulo?.id &&
                                !merge.is_cancelado
                            )
                            .map((merge) => (
                              <MintButton
                                key={merge.id}
                                merge={merge}
                                headers={headers}
                                project_id={project_id}
                                modelo_GUID={modelo_GUID}
                                setdocMap={setdocMap}
                              />
                            ))}



                        </div>

                      </ListSubItemDiv>
                    )}
                  </ul>
                </div>
                //ate aqui
              )}
            </div>

          ))}

        </div>
      </div>
    </div>
  );
};

export default FileUploadBlockchain;